import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  fullWidth?: boolean;
  icon?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  fullWidth = false, 
  className = '', 
  icon,
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center px-6 py-4 border text-sm font-bold uppercase tracking-wider rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 active:scale-95";
  
  const variants = {
    primary: "bg-white text-black border-white hover:bg-gray-200 focus:ring-white shadow-[0_0_15px_rgba(255,255,255,0.2)]",
    secondary: "bg-transparent text-white border-white/20 hover:bg-white/10 focus:ring-white/50",
    danger: "bg-red-600 text-white border-red-600 hover:bg-red-700 focus:ring-red-500",
    ghost: "bg-transparent text-slate-400 border-transparent hover:text-white hover:bg-white/5",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
};